import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,ModalController,LoadingController} from 'ionic-angular';
import { PropertyDocumentChecklistPage } from '../property-document-checklist/property-document-checklist';
import { CommonProvider } from '../../providers/common/common';
import { FinancialdetailsPage } from '../financialdetails/financialdetails';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**
 * Generated class for the PropertyDocumentPickupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-property-document-pickup',
  templateUrl: 'property-document-pickup.html',
})
export class PropertyDocumentPickupPage {
minDate:any="";
model:any={};
arrProperties:any=[];
requestModel:any={};
navparamater:any={};
errorDisplay:any={};
  constructor(private fb: FormBuilder,private fv : GenericFormValidationProvider,private cp: CommonProvider,public navCtrl: NavController, public loadingCtrl: LoadingController, public navParams: NavParams,public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad PropertyDocumentPickupPage');
    
    var date =new Date();
    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var day = date.getDate()
    if(month<10 && day<10){
      this.minDate = year +"-0"+month+"-0"+day
    }else if(month<10 && day>=10){
        this.minDate = year +"-0"+month+"-"+day
    }else if(month>=10 && day<10){
        this.minDate = year +"-"+month+"-0"+day
    }
    else{
      this.minDate = year +"-"+month+"-"+day
    }
    var leadid = this.navParams.get("leadid")
     
    this.veiwLead(leadid); 

     
  }
 presentModal() {
    const modal = this.modalCtrl.create(PropertyDocumentChecklistPage,{showBackdrop: false,
            enableBackdropDismiss: false});
    modal.present();
  }
  goToPickupDocumnet(){
    this.presentModal()
  }
  getTimeSlot(slot){
    //console.log(slot);
    var newSlot=slot.split("-");
    var startTime = this.model.pickupdate+"T"+newSlot[0]+":00.000Z";
    var endTime = this.model.pickupdate+"T"+newSlot[1]+":00.000Z";
    this.requestModel.scheduledend=endTime;
    this.requestModel.scheduledstart=startTime;

  }

  veiwLead(leadid){
    let request:any = {};
      ////console.log(leadid)
      request.leadId=leadid
       
      // ////console.log(request);

      // return false;
      let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      this.cp.viewLeadById(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
          this.navparamater=res
             let applicantPrimary = JSON.parse(res).Payload.lead.applicants.filter((res:any)=>{
              return res.ibhfl_applicantrole=='303710000'
            })
             
            this.arrProperties = JSON.parse(res).Payload.lead.properties
            this.requestModel.ibhfl_ApplicantPickupAddress = applicantPrimary[0].addresses[0].addressid;
           
            this.requestModel.applicantid = applicantPrimary[0].applicantid
            
         }catch(e){
          //console.log(e)
         }
       })
  }

  submitPickupRequest(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["property-pickup"],true,[]);
    if(this.errorDisplay.valid){
     return false;
   }else{
    this.requestModel.subject= "Property Document Pickup"
    //console.log(this.requestModel)
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      this.cp.appointmentmanagement(loading,this.requestModel).then((res:any)=>{
         loading.dismiss();
         try{
             
             this.navCtrl.push(FinancialdetailsPage,this.navparamater)
            
         }catch(e){
          //console.log(e)
         }
       })
    
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/property-document-pickup/property-document-pickup.ts